import { OperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { isDeepEqual } from '../is-deep-equal.util';

export function skipEqual$<T>(): OperatorFunction<T, T> {
  return distinctUntilChanged((object1, object2) => isDeepEqual(object1, object2));
}
